import React from 'react'
import { useDispatch } from 'react-redux'

import { useNavigate } from 'react-router-dom'

// UI
import { Box } from '@chakra-ui/react'

import UserListHeader from '@/features/users/components/UserListHeader'

//API, Hook
import useUser from '@/features/users/useUser'

//Constant, Helper
import { SystemVariableType } from '@/features/systemVariables/constants'
import { UserEditRight } from '../constants'

import { useInitialTableState } from '@/components/Table/components/useInitialTableState'
import FullTable from '@/components/Table/FullTable/FullTable'
import { useContributorGroup } from '@/features/contributorGroups/useContributorGroup'
import { useCostCenter } from '@/features/costCenters/useCostCenter'
import useSystemVariable from '@/features/systemVariables/useSystemVariable'
import { convertTableStateToQuery } from '@/utils/tableHelper'
import getUserTableColumns from '../constants/userTableColumns'
import { LoadingSection } from '@/components/Elements'

const UserListPage = () => {
  // Hooks
  const dispatch = useDispatch()
  const navigate = useNavigate()

  //API
  const { useContributorGroupOptions } = useContributorGroup()
  const { useCostCenterOptions } = useCostCenter()
  const { useFetchAllUsers, useUserOptions } = useUser()
  const { useSystemVariableOptions } = useSystemVariable()

  // Table State
  const [storedTableState, setStoredTableState] = useInitialTableState(`table_state:user`, {})
  const query = convertTableStateToQuery(storedTableState)
  const { data: usersResponse, isLoading } = useFetchAllUsers(query)

  //Options
  const { data: costCenterOptions } = useCostCenterOptions({ status: 'active' })
  const { data: teamsOptions } = useSystemVariableOptions(SystemVariableType.TEAM, { status: 'active' })
  const { data: businessUnitOptions } = useSystemVariableOptions(SystemVariableType.BUSINESS_UNIT, { status: 'active' })
  const { data: contributorGroupsOptions } = useContributorGroupOptions({ status: 'active' })
  const { data: userOptions } = useUserOptions({ status: ['active', 'inactive', 'blocked'] })

  const adminRoleOptions = Object.values(UserEditRight).map((editRight) => {
    return { label: editRight, value: editRight }
  })

  const userTableColumns = getUserTableColumns({
    adminRoleOptions,
    userOptions,
    costCenterOptions,
    teamsOptions,
    businessUnitOptions,
    contributorGroupsOptions,
  })

  const handleOnRowClick = (row) => {
    const user = row.original

    if (user?._id) {
      navigate(`/admin/users/${user._id}/`)
    }
  }

  if (isLoading) {
    return <LoadingSection />
  }

  return (
    <>
      <Box shadow="md" borderWidth="1px" bg="white" w="100%" mb="auto">
        <UserListHeader />
        <Box p={5} overflow="scroll">
          <FullTable
            data={usersResponse?.data ? usersResponse.data : []}
            rowCount={usersResponse?.count}
            columnDef={userTableColumns}
            state={storedTableState}
            setState={setStoredTableState}
            handleRowClick={handleOnRowClick}
            //FIXME:
            userInitialState={{
              filters: [{ id: 'status', value: 'active' }],
            }}
          />
        </Box>
      </Box>
    </>
  )
}

export default UserListPage
